var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-column" }, [
    _c(
      "div",
      {
        staticClass:
          "settings-template flex flex-column ov-reset self-center wp-10"
      },
      [
        _c("Heading", {
          attrs: {
            labelTitle: _vm.currentMenuItemLabel,
            labelTooltip: _vm.$t.__("settings.SettingsTemplate.back_settings"),
            showBackButton: true
          },
          on: { "go-back": _vm.handleGoBack }
        }),
        _vm._v(" "),
        _c("PageLayoutSettings", {
          scopedSlots: _vm._u([
            {
              key: "sidebar",
              fn: function() {
                return [
                  Object.keys(_vm.menuItems).length > 0
                    ? _c("SettingsMenu", {
                        ref: "settingsMenu",
                        attrs: { customMenu: _vm.menuItems }
                      })
                    : _vm._e()
                ]
              },
              proxy: true
            },
            {
              key: "content",
              fn: function() {
                return [
                  _c("router-view", {
                    staticClass: "settings-template__content"
                  })
                ]
              },
              proxy: true
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }